module.exports = __webpack_public_path__ + "img/lushi.8737da0e.png";